export * from "./lib/unary";

import _convertToPromiseClient from "./lib/convertToPromiseClient";

export const convertToPromiseClient = _convertToPromiseClient;
